import { DateTime } from 'luxon';

const dateComparator = (a, b, timeZone) => {
  return (
    DateTime.fromISO(a).setZone(timeZone).valueOf() -
    DateTime.fromISO(b).setZone(timeZone).valueOf()
  );
};

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export { dateComparator, descendingComparator, stableSort };